import React from 'react';

import { AreasTheme } from '../modules/Areas/Themes/AreasTheme';
import { AuditsTheme } from '../modules/Audits/Themes/AuditsTheme';
import { BackOfficeUsersTheme } from '../modules/BackUsers/Themes/BackOfficeUsersTheme';
import { ChallengesTheme } from '../modules/Challenges/Themes/ChallengesTheme';
import {
	CommunicationsTheme,
	DigitalMarketingsTheme,
	LeafletsTheme,
	PartnershipsTheme,
} from '../modules/Communications/Themes/CommunicationsTheme';
import { ContactsTheme } from '../modules/Contacts/Themes/ContactsTheme';
import { EventsTheme, RemindersTheme } from '../modules/Events/Themes/EventsTheme';
import { FrontUsersTheme } from '../modules/FrontUsers/Themes/FrontUsersTheme';
import { GondoleTheme } from '../modules/Gondoles/Themes/GondoleTheme';
import { IndicatorsTheme } from '../modules/Indicators/Themes/indicatorsTheme';
import { newsTheme } from '../modules/News/Themes/NewsTheme';
import { QuizzesTheme } from '../modules/Quizzes/Themes/QuizzesTheme';
import { RolesTheme } from '../modules/Roles/Themes/RolesTheme';
import { SectorsTheme } from '../modules/Sectors/Themes/SectorsTheme';
import { ShopsTheme } from '../modules/Shops/Themes/ShopsTheme';
import { StatsTheme } from '../modules/Stats/Themes/StatsTheme';
import { SurveysTheme } from '../modules/Surveys/Themes/SurveysTheme';
import { TagsTheme } from '../modules/Tags/Themes/TagsTheme';
import { TeamsTheme } from '../modules/Teams/Themes/TeamsTheme';
import { VideosTheme } from '../modules/Videos/Themes/VideosTheme';
import { OffersTheme } from '../modules/Offers/Themes/OffersTheme';
import { EngagementsTheme, OperationsTheme } from '../modules/Operations/Themes/OperationsTheme';
import { CollectionsTheme } from '../modules/Collections/Themes/CollectionsTheme';
import { PinCodesTheme } from '../modules/PinCodes/Themes/PinCodesTheme';
import { EntitiesTheme } from '../modules/Entities/Themes/EntitiesTheme';

export interface IdelinkModuleTheme {
	className?: string;
	backgroundColor?: string;

	//* icons
	emptyIcon?: string;
	navbarIcon?: string;
	listDefaultIcon?: string;
	productDefaultIcon?: string;

	//* permission
	permissionIcon?: string;
	permissionSelectedIcon?: string;
}

export interface IdelingMiscThemes {
	className?: string;
	//* icons
	saveIcon?: string;
	addIcon?: string;
	exportIcon?: string;
	importIcon?: string;
	duplicateIcon?: string;
}

export interface IdeLinkTheme {
	//* ADMIN MODULES
	admins: IdelinkModuleTheme;
	teams: IdelinkModuleTheme;
	entities: IdelinkModuleTheme;
	areas: IdelinkModuleTheme;
	sectors: IdelinkModuleTheme;
	shops: IdelinkModuleTheme;
	users: IdelinkModuleTheme;
	roles: IdelinkModuleTheme;
	stats: IdelinkModuleTheme;
	tags: IdelinkModuleTheme;
	pinCodes: IdelinkModuleTheme;

	//* MODULES
	offers: IdelinkModuleTheme; // PACKAGEDS ORDER - TUNABLE OFFERS - GOODDEALS
	operations: IdelinkModuleTheme;
	engagements: IdelinkModuleTheme;

	communications: IdelinkModuleTheme;
	digitalMarketings: IdelinkModuleTheme;
	partnerships: IdelinkModuleTheme;
	leaflets: IdelinkModuleTheme;

	events: IdelinkModuleTheme;
	reminders: IdelinkModuleTheme;

	videos: IdelinkModuleTheme;
	surveys: IdelinkModuleTheme;
	news: IdelinkModuleTheme;
	challenges: IdelinkModuleTheme;
	indicators: IdelinkModuleTheme;
	quizzes: IdelinkModuleTheme;
	collections: IdelinkModuleTheme;
	audits: IdelinkModuleTheme;
	contacts: IdelinkModuleTheme;
	gondoles: IdelinkModuleTheme;

	loginButton?: IdelinkModuleTheme;
	buttons?: IdelingMiscThemes;
}

export const DefaultIdeLinkTheme: IdeLinkTheme = {
	//* ADMIN MODULES
	admins: BackOfficeUsersTheme,
	teams: TeamsTheme,
	entities: EntitiesTheme,
	areas: AreasTheme,
	sectors: SectorsTheme,
	shops: ShopsTheme,
	users: FrontUsersTheme,
	roles: RolesTheme,
	stats: StatsTheme,
	tags: TagsTheme,
	pinCodes: PinCodesTheme,

	//* MODULES
	offers: OffersTheme,
	operations: OperationsTheme,
	engagements: EngagementsTheme,

	communications: CommunicationsTheme,
	digitalMarketings: DigitalMarketingsTheme,
	partnerships: PartnershipsTheme,
	leaflets: LeafletsTheme,

	events: EventsTheme,
	reminders: RemindersTheme,

	videos: VideosTheme,
	surveys: SurveysTheme,
	news: newsTheme,
	challenges: ChallengesTheme,
	quizzes: QuizzesTheme,
	collections: CollectionsTheme,
	audits: AuditsTheme,
	contacts: ContactsTheme,
	indicators: IndicatorsTheme,
	gondoles: GondoleTheme,
};

export const IdeLinkThemeContext = React.createContext<IdeLinkTheme>(DefaultIdeLinkTheme);
export const useIdelinkTheme = <TTheme extends IdeLinkTheme> (): TTheme => React.useContext(IdeLinkThemeContext) as TTheme;